import { getToken } from "firebase/messaging";
import { initFirebase } from "./firebase";
import API from "../api/adminApi"; 

export const registerNotificationToken = async (userId, role, userName, isRegistration = false) => {
    try {
        const permission = await Notification.requestPermission();

        if (permission !== "granted") {
            console.warn("Notification permission denied");
            return;
        }

        // ✅ Destructure the config from initialization
        const { messaging, vapidKey, config } = await initFirebase();
        if (!messaging || !vapidKey) throw new Error("Firebase failed to initialize properly");

        // ✅ Convert config to a URL query string
        const queryParams = new URLSearchParams(config).toString();

        // ✅ Append the parameters to the Service Worker URL
        const registration = await navigator.serviceWorker.register(`/firebase-messaging-sw.js?${queryParams}`);
        await navigator.serviceWorker.ready;
        console.log("✅ SERVICE WORKER READY");

        const token = await getToken(messaging, {
            vapidKey: vapidKey, 
            serviceWorkerRegistration: registration
        });

        if (token) {
            await API.post("/notifications/save-token", {
                user_id: userId,
                role: role,
                token: token,
                device_name: navigator.userAgent 
            });
            console.log("✅ TOKEN SAVED TO DB");
        } else {
            console.warn("No registration token available. Request permission to generate one.");
        }

    } catch (err) {
        console.error("NOTIFICATION ERROR:", err);
    }
};